import './home.css';
import image from '../../images/news.jpg';
import moodle from '../../images/moodle.png';
import xat from '../../images/xat.webp';
import teacher from '../../images/teacher.png';
import student from '../../images/student.png';
import { Link } from 'react-router-dom';

export const Home = () =>{
    const links = [
        {'image': teacher, 'title': 'HEMIS-Teacher', 'body': 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Debitis autem dolor vel!', 'link': 'https://hemis.tsdi.uz/'},
        {'image': student, 'title': 'HEMIS-Student', 'body': 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Debitis autem dolor vel!', 'link': 'https://student.tsdi.uz/'},
        {'image': moodle, 'title': 'Moodle tizimi', 'body': 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Debitis autem dolor vel!', 'link': 'https://moodle.tsdi.uz/'},
        {'image': xat, 'title': 'e-Xat tizimi', 'body': 'Lorem, ipsum dolor sit amet consectetur adipisicing elit. Debitis autem dolor vel!', 'link': 'https://e-xat.tsdi.uz/'}
    ];
    const links_nav = links.map((data) => 
        <Link to={{pathname: data.link}} target="_blank">
            <nav className='link'>
                <nav className='link-img'>
                    <img src={data.image} alt="" />
                </nav>
                <h3>{data.title}</h3>
                <p>{data.body}</p>
            </nav>
        </Link>
    );

    const stat = [ 
        {'icon': 'fa fa-map', 'number': '123'},
        {'icon': 'fa fa-map', 'number': '124'},
        {'icon': 'fa fa-map', 'number': '125'},
        {'icon': 'fa fa-map', 'number': '126'} 
    ];
    const stat_nav = stat.map((data) => 
                            
        <nav>
            <h3><i className={ data.icon }></i></h3><br />
            <p>{ data.number }</p>
        </nav>
    );

    const news = [
        {'image' : image, 'body': 'Qatarda bo‘lib o‘tayotgan Jahon chempionati finalida Fransiyani mag‘lub etgan Argentina terma jamoasi mundiallarda uchinchi marta chempionlikni qo‘lga kiritdi.'},
        {'image' : image, 'body': 'Qatarda bo‘lib o‘tayotgan Jahon chempionati finalida Fransiyani mag‘lub etgan Argentina terma jamoasi mundiallarda uchinchi marta chempionlikni qo‘lga kiritdi.'},
        {'image' : image, 'body': 'Qatarda bo‘lib o‘tayotgan Jahon chempionati finalida Fransiyani mag‘lub etgan Argentina terma jamoasi mundiallarda uchinchi marta chempionlikni qo‘lga kiritdi.'},
        {'image' : image, 'body': 'Qatarda bo‘lib o‘tayotgan Jahon chempionati finalida Fransiyani mag‘lub etgan Argentina terma jamoasi mundiallarda uchinchi marta chempionlikni qo‘lga kiritdi.'}
    ];

    const news_nav = news.map((data) =>
        <nav className='new-body'>
            <nav className='new-time'>
                <em>Yangilik |</em> 19.12.2022 <i className='fa fa-eye'> 65</i>
            </nav>
            <nav className='news-img'>
                <img src={data.image} alt="rasm" />
            </nav>
            <p className='new-text'>{data.body}</p>
        </nav>
    );

    const services = [
        {'text': 'Elektron kutubxona'},
        {'text': 'Diplomni tasdiqlash'},
        {'text': 'Talaba ma`lumotnomasi'},
        {'text': 'Bosh ilmi-metodik markaz'},
        {'text': 'Google Scholar'},
        {'text': 'ResearchGate'},
        {'text': 'Ish joyidan ma`lumot'},
        {'text': 'Elektron kutubxona'},
        {'text': 'Elektron kutubxona'},
        {'text': 'Elektron kutubxona'}
    ];
    const service = services.map((data) =>
        <nav className='serv'>
            <Link>
                <p>{data.text}</p>
            </Link>
        </nav>
    );

    return(
        <div className="home">

            <div className="sliders">
                <div className="slider">
                    
                </div>
            </div>

            <div className="links">
                <div className="content">
                    <nav className='link-box'>
                        {links_nav}
                    </nav>
                </div>
            </div>

            <div className="statistika">
                <div className="content">
                    <div className="stat-circle">
                        {stat_nav}
                    </div>
                </div>
            </div>

            <div className="divider">
                <div className="content">
                    <nav>
                        <h4><i className='fa fa-graduation-cap'></i> O`quv-uslubiy bo`lim</h4><br />
                        <p>Toshkent davlat Stamotologiya Instituti</p>
                    </nav>
                    <ul className='divider-list'>
                        <li><Link to='https://t.me/Developer1524'><i className='fa fa-paper-plane cltg'></i></Link></li>
                        <li><Link><i className='fa fa-twitter cltwitter'></i></Link></li>
                        <li><Link><i className='fa fa-facebook clfacebook'></i></Link></li>
                        <li><Link><i className='fa fa-youtube clyoutube'></i></Link></li>
                        <li><Link><i className='fa fa-instagram clinsta'></i></Link></li>
                    </ul>
                </div>
            </div>

            <div className="news">
                <div className="content">
                    <nav className='news-title'>
                        <hr />
                        <p>Bo`lim yangiliklari</p>
                        <hr />
                    </nav>
                    <div className='new-box'>
                        {news_nav}
                    </div>
                </div>
            </div>

            <div className="services">
                <div className="content">
                    {service}
                </div>
            </div><br /><br /><br />

        </div>
    )
}